module.exports = __webpack_public_path__ + "static/img/closing-title.48edbb5e.png";